import { Type } from '@sinclair/typebox';
export const LogLevelSchema = Type.Union([
    Type.Literal('debug'),
    Type.Literal('info'),
    Type.Literal('warn'),
    Type.Literal('error'),
]);
export const LogAttributesSchema = Type.Record(Type.String(), Type.Union([Type.String(), Type.Number(), Type.Boolean()]));
export const LogBodySchema = Type.Object({
    level: LogLevelSchema,
    eventType: Type.String({ minLength: 1, maxLength: 128 }),
    attributes: LogAttributesSchema,
});
//# sourceMappingURL=telemetry.js.map